import { ResponsiveContainer } from "recharts";
import { ProgressSectionState } from "./ProgressSectionStatus";
import { CHART_MIN_HEIGHT } from "./progressChartUtils";

const HEIGHT_CLASS = {
  [CHART_MIN_HEIGHT.volume]: "min-h-72 h-72",
  [CHART_MIN_HEIGHT.training]: "min-h-64 h-64",
  [CHART_MIN_HEIGHT.history]: "min-h-52 h-52",
  [CHART_MIN_HEIGHT.power]: "min-h-72 h-72",
};

export const ProgressChartContainer = ({
  title,
  ariaLabel,
  testId,
  summary,
  chartState,
  emptyTitle,
  emptyDescription,
  emptyTestId,
  unavailableTitle,
  unavailableDescription,
  unavailableTestId,
  minHeight = CHART_MIN_HEIGHT.volume,
  className = "",
  children,
}) => {
  if (chartState === "empty") {
    return (
      <ProgressSectionState
        variant="empty"
        title={emptyTitle}
        description={emptyDescription}
        testId={emptyTestId}
      />
    );
  }

  if (chartState === "all-null") {
    return (
      <ProgressSectionState
        variant="unavailable"
        title={unavailableTitle}
        description={unavailableDescription}
        testId={unavailableTestId}
      />
    );
  }

  const heightClass = HEIGHT_CLASS[minHeight] || "min-h-64 h-64";
  const accessibleLabel = ariaLabel || title || "Progress chart";

  return (
    <div
      className={`w-full max-w-full overflow-hidden rounded-md ${heightClass} ${className}`.trim()}
      data-testid={testId}
      role="group"
      aria-label={accessibleLabel}
    >
      {summary ? (
        <p className="sr-only" data-testid={testId ? `${testId}-summary` : undefined}>
          {summary}
        </p>
      ) : null}
      <ResponsiveContainer width="100%" height="100%">
        {children}
      </ResponsiveContainer>
    </div>
  );
};
